module.exports = __webpack_public_path__ + "img/bp_xy_g13.32df28df.webp";